<template>
<div class="col-sm-12">
    <div class="mt-2">
        <div class="row pl-3 pr-3">
            <div class="col-md-6 mt-4-custom">
                <input type="text" placeholder="Search ..." v-model="searchQueryTraining" class="search_button ques-search form-control form-control-sm" @keyup.enter="filterData" @input="callSearch" />
                <button class="clear_button" @click="AllQuestions">Search</button>
                <i v-if="searchQueryTraining !== ''" class="material-icons close_icon2" @click="clearSearch">close</i>
            </div>
            <div class="col-md-6">
                <label for="FilterbyThematicArea">
                    <b>Filter by Thematic Area</b>
                </label>
                <selectize id="select-state" class="text-capitalize form-control-md" v-model="thematicArea" :settings="departmentSetting" :searchable="true">
                    <option value="">All</option>
                    <option v-for="(item, index) in thematicAreaArr" :key="index" :value="item.id" class="text-capitalize">
                        {{ item.name }}
                    </option>
                </selectize>
            </div>
            <div class="col-sm-12 float-right mb-2 p-0 ">
                <Pagination :current-page="currentPage" :record-limit="recordLimit" :total-counts="totalCounts" @prev-page="prevPage" @next-page="nextPage" @go-to-page="goToPage" />
            </div>
            <div class="col-sm-12 page-count float-right">
                {{((currentPage-1)*50)+feedbackQuestions.length}} Records out of
                {{this.totalCounts}}
            </div>
        </div>

        <br />
        <b-card no-body style="border: none !important">
            <b-tabs pills card vertical>
                <b-tab :title-item-class="'tab-title-class'" disabled title="Filter by" style></b-tab>
                <div>
                    <b-tab title="All" @click="changeActive(0)">
                        <b-card-text v-for="(tquestion, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                            <div class="col-md-12">
                                <div class="tab-item">
                                    <h6 class="tab-item__heading mb-1">
                                        <b>Q )</b>
                                        {{ tquestion.title }} ?
                                    </h6>
                                    <div v-for="(toptions, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                        <template>
                                            <div v-for="(ttopt, optindex) in toptions" :key="optindex">
                                                <div v-if="ttopt.questionBank_id == tquestion.id" class="inner_options_dev" :class="{ correct: ttopt.status == 1 }">
                                                    {{ ttopt.title }}
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>
                </div>

                <b-tab title="Assessment" @click="changeActive(1)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(opt, optindex) in options" :key="optindex">
                                            <div v-if="opt.questionBank_id == feedback.id" class="inner_options_dev" :class="{ correct: opt.status == 1 }">
                                                {{ opt.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Facilitator's Feedback" @click="changeActive(2)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(opt, optindex) in options" :key="optindex">
                                            <div v-if="opt.questionBank_id == feedback.id" class="inner_options_dev">
                                                {{ opt.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Participant's Feedback" @click="changeActive(3)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(kptOptions, kptindex) in options" :key="kptindex">
                                            <div v-if="kptOptions.questionBank_id == feedback.id" class="inner_options_dev">
                                                {{ kptOptions.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>

                <hr />
                <b-tab disabled title="Filter by Level"></b-tab>
                <b-tab title="Basic" @click="changeLevel(6)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(ywoptions, ywindex) in options" :key="ywindex">
                                            <div v-if="ywoptions.questionBank_id == feedback.id" class="inner_options_dev" :class="{ correct: ywoptions.status == 1 }">
                                                {{ ywoptions.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Intermediate" @click="changeLevel(7)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(kdOptions, Kdindex) in options" :key="Kdindex">
                                            <div v-if="kdOptions.questionBank_id == feedback.id" class="inner_options_dev" :class="{ correct: kdOptions.status == 1 }">
                                                {{ kdOptions.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Advanced" @click="changeLevel(8)">
                    <b-card-text v-for="(feedback, optionsCounter) in feedbackQuestions" :key="optionsCounter">
                        <div class="col-md-12">
                            <div class="tab-item">
                                <h6 class="tab-item__heading mb-1">
                                    <b>Q )</b>
                                    {{ feedback.title }} ?
                                </h6>
                                <div v-for="(options, index) in feedbackQuestionOptions" :key="index" class="option_type">
                                    <template>
                                        <div v-for="(ppoptions, ppindex) in options" :key="ppindex">
                                            <div v-if="ppoptions.questionBank_id == feedback.id" class="inner_options_dev" :class="{ correct: ppoptions.status == 1 }">
                                                {{ ppoptions.title }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import Selectize from "vue2-selectize";
import Pagination from '../../components/Pagination.vue';

Vue.component('Pagination', Pagination);

export default {
    components: {
        Pagination,
        Selectize
    },
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        themetic_area: "",
        level: "",
        category: "",
        feedbackQuestions: [],
        feedbackQuestionOptions: [],
        thematicAreaArr: [],
        searchQueryTraining: "",
        thematicQuestionsOptions: [],
        thematicQuestions: [],
        thematicArea: [],
        tfilter: false,
        thematicFilter: [],
        departmentSetting: {
            maxItems: 1,
            searchField: ["title"],
            plugins: ["remove_button"],
            placeholder: "Select Thematic area",
        },
        isSidebar: false,
    }),
    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.AllQuestions();

        axios
            .get(localStorage.getItem("BASE_PATH") + "/show/thematicArea/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.thematicAreaArr = response.data;
            });
    },

    watch: {
        thematicArea(val) {
            this.themetic_area = val
            this.AllQuestions()
        },
    },
    methods: {
        AllQuestions: function AllQuestions() {
            this.openLoading();
            axios
                .post(localStorage.getItem("BASE_PATH") + "/ques_bank/get", {
                    "offSet": this.offSet,
                    "searchText": this.searchQueryTraining,
                    "themetic_area": this.themetic_area,
                    "level": this.level,
                    "category": this.category,
                })
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.feedbackQuestions = response.data["questionArray"];
                    this.feedbackQuestionOptions = response.data.optionArray;
                    this.totalCounts = response.data.totalCount;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.currentOffset;
                    this.thematicQuestions = this.feedbackQuestions;
                    this.thematicQuestionsOptions = this.feedbackQuestionOptions;
                });
        },

        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        changeActive(a) {
            if (a == 0) {
                this.clearSearch()
            } else {
                this.category = a.toString()
                this.AllQuestions()
            }
        },
        changeLevel(b) {
            this.level = b.toString()
            this.AllQuestions()
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.AllQuestions();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.AllQuestions();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.AllQuestions();
        },
        filterData() {
            this.currentPage = 1
            this.offSet = 0
            this.AllQuestions();
        },
        clearSearch() {
            this.currentPage = 1
            this.offSet = 0
            this.searchQueryTraining = ""
            this.category = ""
            this.level = ""
            this.AllQuestions();
        },
        callSearch() {
            if (this.searchQueryTraining.length == 0) {
                this.AllQuestions();
            }
        }
    },
    computed: {
        questionFilter: function () {
            return this.feedbackQuestions.filter((items) => {
                for (var item in items) {

                    if (
                        String(items[item])
                        .toLowerCase()
                        .indexOf(this.searchQueryTraining.toLowerCase()) !== -1
                    ) {
                        return true;
                    }
                }
                return false;
            });
        },
    },
};
</script>

<style>
.nav-link.disabled {
    font-weight: bold !important;
    font-size: 15px !important;
    color: #6c757d;
    pointer-events: none;
    cursor: default;
}
</style><style scoped>
#menu-toggle {
    display: none;
}

.card-body {
    padding: 0px !important;
}

.tab-item {
    background: white;
    border: 1px #d5dadf solid;
    border-left: 1px solid #d5dadf;
    box-shadow: 0 2px 3px rgba(213, 218, 223, 0.35);
    padding: 15px;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 15px;
}

.tab-item:hover,
.tab-item.active {
    box-shadow: 0px 3px 3px 2px rgba(213, 218, 223, 0.35);
    border-left: 1px solid #009ad2;
}

.tab-item__heading {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.3em;
    letter-spacing: 0.02em;
    color: #6c757d;
    margin: 0px;
}

.tab-item__subheading {
    font-size: 15px;
    color: #6c757d;
    margin: 0px;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.correct {
    color: green;
    font-weight: bold;
}

.ques-search {
    height: 34px !important;
}

.mt-4-custom {
    margin-top: 27px;
}

.page-count {

    font-size: 15px;
    color: #06a6e0;
}

.search_button {
    position: relative
}

.clear_button {
    position: absolute;
    right: 15px !important;
    height: 34px !important;
    top: 0px;
    width: 80px;
    border-radius: 5px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: #ffffff;
    font-size: 15px;
}

.close_icon2 {
    position: absolute;
    right: 100px !important;
    top: 6px !important;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 24px !important;
}
</style>
